import { ACTIONS_MACHINE_CLASS } from '../_constants/machineClass.constants';

const initialState = {
  byId: {},
};

export function machineClassReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case ACTIONS_MACHINE_CLASS.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_MACHINE_CLASS.DELETE:
    {
      const currentById = { ...state.byId };
      delete currentById[Object.keys(action.byId)[0]];

      return {
        ...state,
        byId: currentById,
      };
    }

    case ACTIONS_MACHINE_CLASS.RECEIVE: {
      return {
        ...state,
        byId: { ...state.byId, ...action.byId },
      };
    }

    default:
      return state;
  }
}

export default machineClassReducer;
